import { DateUtil } from './dateUtil'
import { QNImageUtil } from './qiniuImageUtil'
import { StringUtil } from './stringUtil'
import { RegExpr } from './regex'
import { UrlUtil } from './urlUtil'
import { ArrayUtil } from './arrayUtil'
import { ToolUtil } from './toolUtil'
import { SiteUtil } from './siteUtil'
import { debounce } from './debounce'
import { deepClone } from './deepClone'
import wx from 'weixin-js-sdk'

/**
 * 时间转换
 * eg: 2021-07-27 19:00:00 -> parseTime(time, '{y}-{m}-{d} {h}:{i}{s}')
 * cFormat可以根据自己需求格式写
 * eg: 2021/07/27 19:00 -> parseTime(time, '{y}/{m}/{d} {h}:{i}')
 * eg: 19:00 -> parseTime(time, '{h}:{i}')
 * ....
 * ....
 * 转换为周几: `周${parseTime(time, '{a}')}`
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if (typeof time === 'string') {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time
                    .replace(/-/g, '/')
                    .replace('T', ' ')
                    .replace(/\+[0-9:]+/gi, '')
            }
        }

        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

export function colorRgb(hex) {
    let sColor = hex.toLowerCase();
    //十六进制颜色值的正则表达式
    const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
    // 如果是16进制颜色
    if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
            let sColorNew = "#"
            for (let i = 1; i < 4; i += 1) {
                sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
            }
            sColor = sColorNew
        }
        //处理六位的颜色值
        const sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
            sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)))
        }
        return sColorChange.join(",")
    }
    return sColor
}

function IsOnPC() {
    var userAgentInfo = navigator.userAgent
    var Agents = ['Android', 'iPhone',
        'SymbianOS', 'Windows Phone',
        'iPad', 'iPod']
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false
            break
        }
    }
    return flag
}

export function removeUrlQueryItem(url, queryName) {
  if(url.indexOf(queryName) >= 0 && url.indexOf(url) >= 0){
    const parts = url.split('?');
    // 处理查询参数
    const params = parts[1].split('&');
    const newParams = params.filter(param => {
      const parts2 = param.split('=');
      return parts2[0] != queryName;
    });
    // 重建URL
    return newParams.length > 0 ? `${parts[0]}?${newParams.join('&')}` : url;
  } else {
    return url;
  }
}

export function goNewVersionPage(params) {
    var hostname = window.location.hostname;
    var pathname = window.location.pathname;
    var env = 'dev';
    if (hostname === 'localhost') {
        env = 'dev';
    } else {
        if (pathname.indexOf('stage') > -1 || pathname.indexOf('dev') > -1) {
            env = 'dev';
        } else {
            env = 'prod';
        }
    }
    var url = ''
    var devBaseSiteUrl = 'https://www.snsports.cn/webapp-bmb-stage/index.html#/'
    var prodBaseSiteUrl = 'https://www.snsports.cn/webapp-bmb/index.html#/'
    var baseUrl = env === 'prod' ? prodBaseSiteUrl : devBaseSiteUrl
    if (params.path === 'gameSummary') {
        url = baseUrl + 'game1/' + params.gameId
    } else {
        url = baseUrl + 'game1/' + params.gameId + params.path
    }
    if (params.language) {
        url += `?language=${params.language}`
    }
    window.location.href = url
}
function getDateObjectByString(dateString) {
    var convertedDateString = dateString.replace(/-/g, '/').replace('T', ' ').replace(/\+[0-9:]+/ig, '')// 为了兼容ios的时间格式转化
    return convertedDateString ? new Date(convertedDateString) : ''
}
export function getWeekdayStringByDateString(dateString, disableNaturalDay) {
    if (!dateString) {
        return ''
    }
    var theDate = getDateObjectByString(dateString)
    var now = new Date()
    var weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'] // 创建星期数组

    if (disableNaturalDay) return weekdays[theDate.getDay()]

    var todayBegin = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    var yesterdayBegin = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
    var tomorrowBegin = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
    var theDayAfterTomorrowBegin = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2)
    if (theDate.getTime() < theDayAfterTomorrowBegin.getTime() && theDate.getTime() >= tomorrowBegin.getTime()) {
        return '明天'
    } else if (theDate.getTime() < tomorrowBegin.getTime() && theDate.getTime() >= todayBegin.getTime()) {
        return '今天'
    } else if (theDate.getTime() < todayBegin.getTime() && theDate.getTime() >= yesterdayBegin.getTime()) {
        return '昨天'
    } else {
        return weekdays[theDate.getDay()] // 返一个星期中的某一天，其中0为星期日
    }
}

/**
 * 判断是否为微信小程序
 * @export
 * @returns
 */
function isWeChatMiniApp() {
    const ua = window.navigator.userAgent.toLowerCase()
    return new Promise((resolve) => {
        if (ua.indexOf('micromessenger') === -1) { // 不在微信或者小程序中
            resolve(false)
        } else {
            // eslint-disable-next-line
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    resolve(true)
                } else { // 在微信中
                    resolve(false)
                }
            })
        }
    })
}

const AppType = {
  isInWeChat: function() { // 判断是否是在微信内打开
    return /MicroMessenger/i.test(window.navigator.userAgent)
  },
  isInQQ: function() { // 判断是否是在微信内打开
    return /QQ/i.test(window.navigator.userAgent) && /mobile/i.test(window.navigator.userAgent)
  },
  isInApp: function() { // 包含bmb and bmLive
    return /Banma/i.test(window.navigator.userAgent)
  },
  isInBmApp: function() {
    return /Banma/i.test(window.navigator.userAgent) && !(/BanmaLive/i.test(window.navigator.userAgent))
  },
  isInLiveApp: function() {
    return /BanmaLive/i.test(window.navigator.userAgent)
  },
  isInAndroid: function() { // android终端
    var u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  },
  isInIOS: function() { // ios终端
    var u = navigator.userAgent
    //return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return /iPhone|iPad|iPod/i.test(u)
  },
  isInMiniProgram: function () { // 判断是否是在小程序内打开
    return /miniprogram/i.test(window.navigator.userAgent);
  }
}

export { DateUtil, QNImageUtil, StringUtil, UrlUtil, RegExpr, ArrayUtil, ToolUtil, SiteUtil, debounce, deepClone, IsOnPC, isWeChatMiniApp, AppType }
export { notifyMiniProgramShare, buildWebviewShareFullUrl } from './mini-program-share'
